import React from "react";
import DateFormatting from "../../common_components/DateFormatting";

function SessionTitleRow(props) {
    const [date, time] = DateFormatting.parseISOStringToReadableDateAndTime(props.session.start_time, props.timezone)
    const longDate = DateFormatting.parseISOStringToLongDate(props.session.start_time, props.timezone)
    return (
        <div className="session-title-row">
            <div className="session-title-text">
                {props.session.first_name + "'s Session"}
            </div>
            <div className="session-title-date">
                {longDate + " | " + time}
            </div>
        </div>
    )
}

export default SessionTitleRow;